import { render, staticRenderFns } from "./PDFMaterial.vue?vue&type=template&id=0d096745&scoped=true&"
import script from "./PDFMaterial.vue?vue&type=script&lang=js&"
export * from "./PDFMaterial.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/pdf_material.css?vue&type=style&index=0&id=0d096745&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d096745",
  null
  
)

export default component.exports